import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MoreIcon from '@material-ui/icons/MoreVert';
import firebase from 'firebase';

const styles = theme => ({
    root: {
        width: '100%',
        marginLeft: 0,

        [theme.breakpoints.up('md')]: {
            width: 'calc(100% - 210px)',
            marginLeft: 210,
        },
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    title: {
        display: 'none',
        fontFamily: 'Poppins',
        marginLeft: '11%',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        position: 'relative',
        borderColor: 'red',
        border: '0px solid red',
        boxShadow: '0px 0px 0px -1px rgba(0, 0, 0, 0.2), 0px 0px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 0px 0px rgba(0, 0, 0, 0.12)',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
});

class AppBarComponent extends React.Component {
    state = {
        anchorEl: null,
        anchorElPort: null,
        mobileMoreAnchorEl: null,
        btc: true,
        name: ''
    };
    componentDidMount() {
        var context = this;
        var db = firebase.firestore();
        db.collection('campaigns').where('adminUID','==', this.props.user.uid).get().then(function (camps) {
            camps.forEach(function (camp) {
                context.setState({name: camp.data().name})
            })
        })
    }

    handleProfileMenuOpen = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    handlePortfolioMenuOpen = event => {
        this.setState({ anchorElPort: event.currentTarget });
    };

    handleMenuClose = () => {
        this.setState({ anchorEl: null });
        this.handleMobileMenuClose();
    };
    handlePortfolioMenuClose = () => {
        this.setState({ anchorElPort: null });
        this.handleMobileMenuClose();
    };

    handleMobileMenuOpen = event => {
        this.setState({ mobileMoreAnchorEl: event.currentTarget });
    };

    handleMobileMenuClose = () => {
        this.setState({ mobileMoreAnchorEl: null });
    };

    logOut = () => {
        firebase.auth().signOut()
            .then(function() {
                // Sign-out successful.
            })
            .catch(function(error) {
                // An error happened
            });
    };

    handleHambMenu = () => {

    };


    render() {
        const { anchorEl, mobileMoreAnchorEl, anchorElPort } = this.state;
        const { classes } = this.props;
        const isMenuOpen = Boolean(anchorEl);
        const isMenuOpenPort = Boolean(anchorElPort);
        const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

        const theme = createMuiTheme({
            palette: {
                primary: {
                    // light: will be calculated from palette.primary.main,
                    main: '#F9F9F9',
                    // dark: will be calculated from palette.primary.main,
                    // contrastText: will be calculated to contrast with palette.primary.main
                }
            },
            typography: { useNextVariants: true },
        });

        const renderMenu = (
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMenuOpen}
                onClose={this.handleMenuClose}
            >
                <MenuItem onClick={() => {this.handleMenuClose(); this.props.handleOpenModals(6)}}>Cambiar contraseña</MenuItem>
                <MenuItem onClick={() => {this.handleMenuClose(); this.logOut()}}>Cerrar sesion</MenuItem>
                {/*<MenuItem onClick={this.handleMenuClose}>Nuevo Admin</MenuItem>
                <MenuItem onClick={this.handleMenuClose}>Nuevo Portfolio</MenuItem>*/}
            </Menu>
        );


        const renderMobileMenu = (
            <Menu
                anchorEl={mobileMoreAnchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMobileMenuOpen}
                onClose={this.handleMobileMenuClose}
            >

                <MenuItem onClick={this.props.handleCurrency}>
                    <IconButton color={"inherit"}>
                        <i className={'ion ion-md-refresh'}/>
                    </IconButton>
                    <p>Actualizar</p>
                </MenuItem>
                {/*<MenuItem>

                    <IconButton color="inherit">
                        <Badge badgeContent={11} color="secondary">
                            <img src={alarm} className={"bellIcon"}/>
                        </Badge>
                    </IconButton>
                    <p>Notifications</p>
                </MenuItem>*/}
                <MenuItem onClick={this.handleProfileMenuOpen}>
                    <IconButton color="inherit">
                        <AccountCircle />
                    </IconButton>
                    <p>Profile</p>
                </MenuItem>
            </Menu>
        );

        return (
            <div className={classes.root}>
                <MuiThemeProvider theme={theme}>
                <AppBar position="fixed" className={'appBar'}>
                    <Toolbar>
                        <IconButton className={classes.menuButton} color="inherit" aria-label="Open drawer" onClick={this.props.handleDrawerToggle}>
                            <MenuIcon />
                        </IconButton>
                        <Typography className={classes.title} variant="h6" color="inherit" noWrap>
                            {this.state.name}
                        </Typography>
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <InputBase
                                onChange={this.props.handleSearch}
                                value={this.props.searchVal}
                                placeholder="Search…"
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                            />
                        </div>
                        <div className={classes.grow} />
                        <div className={classes.sectionDesktop}>



                            <IconButton color={"inherit"} onClick={this.props.handleCurrency} >
                                <i className={'ion ion-md-refresh'}/>
                            </IconButton>
                           {/* <IconButton color="inherit">
                                <Badge badgeContent={17} color="secondary">
                                    <img src={alarm} className={"bellIcon"}/>
                                </Badge>
                            </IconButton>*/}
                            <IconButton
                                aria-owns={isMenuOpen ? 'material-appbar' : undefined}
                                aria-haspopup="true"
                                onClick={this.handleProfileMenuOpen}
                                color="inherit"
                            >
                                <AccountCircle />
                            </IconButton>
                        </div>
                        <div className={classes.sectionMobile}>
                            <IconButton aria-haspopup="true" onClick={this.handleMobileMenuOpen} color="inherit">
                                <MoreIcon />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>
                {renderMenu}
                {renderMobileMenu}
                </MuiThemeProvider>
            </div>
        );
    }
}

AppBarComponent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AppBarComponent);